export class UploadedFile {
  file: File;
  blobUrl: string;
  constructor(file: File, blob: string) {
    this.file = file;
    this.blobUrl = blob;
  }
}
